export type {
  GenerateDescription,
  GenerateImage,
  GenerateTitle,
  GenerateURL,
  Meta,
  SEOPluginConfig,
} from '../types.js'
